import React from 'react';
import MyCheckBox from '../../../UI/checkbox/MyCheckBox';
import './../../../Styles/Main/RentalPage/RentalRequestBike.scss';


function RentalRequestBike({ ...props }) {
   

   return (
      <div className='requestedBike__body'>
         <div className="requestedBike__image">
            <img src={"../image/" + props.image} alt=""/>
         </div>
         <div className="requestedBike__bikeName text">{props.name}</div>
         <div className="requestedBike__helmet requestedBike__accessories">
            <MyCheckBox/>
         </div>
         <div className="requestedBike__lights requestedBike__accessories">
            <MyCheckBox/>
         </div>
         <div className="requestedBike__lock requestedBike__accessories">
            <MyCheckBox/>
         </div>
         <div className="requestedBike__price color-text">{ props.price }</div>
      </div>
   );
}
export default RentalRequestBike;